module.exports = __webpack_public_path__ + "media/images/emblems/Bure.blason-bf3737e18883496b469d0e0060ec2400.png";